export const removeEmpty = (obj) => {
    Object.keys(obj).forEach((key) => {
        (obj[key] && typeof obj[key] === 'object') && (obj[key]= removeEmpty(obj[key]));
        (obj[key] === '' || obj[key] === null || obj[key] === undefined) && delete obj[key];
    });
    return Object.keys(obj).length > 0 ? obj : undefined;
};
